/* ============================================================
   TheTransformationLab — content rendering + lightbox
   ============================================================ */
(function () {
  'use strict';
  var T = window.TLAB; if (!T) return;
  var page = document.body.dataset.page || '';

  function fig(file, w) {
    return '<div class="ph"><img loading="lazy" decoding="async" ' +
      'alt="Transformation journey" src="' + T.W(file, w) + '"></div>';
  }

  var PLAY = '<span class="play" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>';

  /* ---------- client story videos ----------
     On Shopify the layout defines window.TLAB_MEDIA with Files CDN urls;
     standing alone the site falls back to its own /media folder.        */
  var M = window.TLAB_MEDIA || null;
  function mp4(f) { return M && M[f] ? M[f].mp4 : 'media/' + f + '.mp4'; }
  function poster(f) { return M && M[f] ? M[f].poster : 'media/' + f + '.jpg'; }

  function vidTile(v, i, cls) {
    return '<div class="g vid ' + (cls || '') + '" data-lb="' + mp4(v.f) + '" data-lb-type="video" ' +
      'data-poster="' + poster(v.f) + '">' +
      '<div class="ph"><img loading="lazy" decoding="async" alt="Client transformation story" ' +
      'src="' + poster(v.f) + '">' + PLAY + '<span class="vid__dur">' + v.dur + '</span></div>' +
      '<div class="gmeta"><b>Transformation Story</b><span>' +
      String(i + 1).padStart(2, '0') + ' / ' + T.VIDEOS.length + '</span></div></div>';
  }

  document.querySelectorAll('[data-videos]').forEach(function (host) {
    host.innerHTML = T.VIDEOS.map(function (v, i) { return vidTile(v, i, 'rv'); }).join('');
  });

  /* ============================================================
     PHOTO SOURCE
     The shop owner manages the gallery from the Transformations
     page's own Content box in Shopify admin. Whatever images they
     put there become the gallery, in that order. If that box holds
     no images we fall back to the built-in list.
     ============================================================ */
  function photosFromPage() {
    var el = document.getElementById('tlab-photos');
    if (!el || !el.textContent.trim()) return null;
    var doc;
    try { doc = new DOMParser().parseFromString(el.textContent, 'text/html'); }
    catch (e) { return null; }
    var imgs = doc.querySelectorAll('img'), out = [], seen = {};
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].getAttribute('src') || imgs[i].getAttribute('data-src') || '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      if (!src || seen[src]) continue;
      seen[src] = 1;
      out.push(src);
    }
    return out.length ? out : null;
  }

  // ask the Shopify CDN for a given render width
  function sized(u, w) {
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var OWN = photosFromPage();
  var PHOTOS = OWN || T.PEOPLE.map(function (f) { return T.W(f, 1000); });
  T.PHOTOS = PHOTOS;
  T.ownPhotos = !!OWN;

  function photo(u, w) {
    return '<div class="ph"><img loading="lazy" decoding="async" ' +
      'alt="Transformation journey" src="' + sized(u, w) + '"></div>';
  }

  /* ---------- home: horizontal photo strip ---------- */
  var strip = document.querySelector('[data-strip]');
  if (strip) {
    strip.innerHTML = PHOTOS.slice(0, 12).map(function (u, i) {
      return '<div class="strip__item" data-lb="' + sized(u, 1400) + '">' +
        photo(u, 700) +
        '<div class="strip__cap"><span>' + T.LABELS[i % T.LABELS.length] + '</span>' +
        '<span>' + String(i + 1).padStart(2, '0') + '</span></div></div>';
    }).join('');
  }

  /* ---------- transformations: full grid ---------- */
  var grid = document.querySelector('[data-grid]');
  if (grid) {
    grid.innerHTML = PHOTOS.map(function (u, i) {
      var tall = i % 5 === 2 ? ' g--tall' : '';
      return '<div class="g rv' + tall + '" data-lb="' + sized(u, 1600) + '">' +
        photo(u, 800) +
        '<div class="gmeta"><b>' + T.LABELS[i % T.LABELS.length] + '</b>' +
        '<span>' + String(i + 1).padStart(2, '0') + ' / ' + PHOTOS.length + '</span></div></div>';
    }).join('');
  }

  /* ---------- products grid ---------- */
  var prods = document.querySelector('[data-prods]');
  if (prods) {
    prods.innerHTML = T.PRODUCTS.map(function (p) {
      return '<article class="prod rv">' + fig(p.f, 500) +
        '<h4>' + p.t + '</h4>' +
        '<div class="prod__row"><span class="prod__old">Rs. ' + p.p + '.00</span>' +
        '<span class="prod__free">Included free</span></div></article>';
    }).join('');
  }

  /* ---------- hero portrait ---------- */
  var shot = document.querySelector('[data-shot]');
  if (shot) shot.innerHTML = fig(T.HERO_SHOT, 1200);

  document.dispatchEvent(new Event('tlab:render'));

  /* ============================================================
     LIGHTBOX — full-screen viewer with next / prev / swipe
     ============================================================ */
  var lb = document.querySelector('.lb');
  if (lb) {
    var img = lb.querySelector('img');
    var counter = lb.querySelector('.lb__count');
    var capt = lb.querySelector('.lb__cap');
    var items = [], idx = 0, open = false;

    function collect() {
      items = Array.prototype.slice.call(document.querySelectorAll('[data-lb]'));
    }

    var stage = lb.querySelector('.lb__stage');
    var vid = null;

    function stopVideo() {
      if (vid) { try { vid.pause(); } catch (e) {} vid.removeAttribute('src'); vid.load(); vid.remove(); vid = null; }
    }

    function show(i, dir) {
      if (!items.length) return;
      idx = (i + items.length) % items.length;
      var el = items[idx];
      stopVideo();
      img.style.setProperty('--dir', dir || 0);

      if (el.dataset.lbType === 'video') {
        img.classList.remove('is-in');
        img.hidden = true;
        vid = document.createElement('video');
        vid.className = 'lb__video';
        vid.src = el.dataset.lb;
        if (el.dataset.poster) vid.poster = el.dataset.poster;
        vid.controls = true;
        vid.autoplay = true;
        vid.playsInline = true;
        vid.setAttribute('playsinline', '');
        vid.preload = 'auto';
        stage.appendChild(vid);
        requestAnimationFrame(function () { vid && vid.classList.add('is-in'); });
        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        img.hidden = false;
        img.classList.remove('is-in');
        var next = new Image();
        next.onload = next.onerror = function () {
          img.src = next.src;
          requestAnimationFrame(function () { img.classList.add('is-in'); });
        };
        next.src = el.dataset.lb;
      }

      if (counter) counter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      if (capt) {
        var b = el.querySelector('.gmeta b, .strip__cap span');
        capt.textContent = b ? b.textContent : '';
      }
      // warm the neighbouring stills so next/prev feel instant
      [items[(idx + 1) % items.length], items[(idx - 1 + items.length) % items.length]]
        .forEach(function (n) {
          if (n && n.dataset.lbType !== 'video') { var p = new Image(); p.src = n.dataset.lb; }
        });
    }

    function openAt(el) {
      collect();
      var i = items.indexOf(el);
      if (i < 0) return;
      open = true;
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { lb.classList.add('is-on'); });
      show(i, 0);
      // ask the browser for real full-screen where it is allowed
      if (lb.requestFullscreen) {
        try { var fr = lb.requestFullscreen(); if (fr && fr.catch) fr.catch(function () {}); }
        catch (e) {}
      }
    }

    function close() {
      if (!open) return;
      open = false;
      lb.classList.remove('is-on');
      document.body.style.overflow = '';
      if (document.fullscreenElement && document.exitFullscreen) {
        try { document.exitFullscreen(); } catch (e) {}
      }
      stopVideo();
      setTimeout(function () {
        lb.hidden = true; img.src = ''; img.hidden = false; img.classList.remove('is-in');
      }, 340);
    }


    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-lb]');
      if (t && !open) { e.preventDefault(); openAt(t); return; }
      if (!open) return;
      if (e.target.closest('.lb__next')) { show(idx + 1, 1); return; }
      if (e.target.closest('.lb__prev')) { show(idx - 1, -1); return; }
      if (e.target.closest('.lb__x') || e.target === lb ||
          (e.target.closest('.lb__stage') && e.target.tagName !== 'IMG' && e.target.tagName !== 'VIDEO')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1, 1);
      else if (e.key === 'ArrowLeft') show(idx - 1, -1);
    });

    /* swipe between items — ignored while the pointer is on the video controls */
    var sx = 0, sy = 0, tracking = false;
    lb.addEventListener('pointerdown', function (e) {
      if (e.target.tagName === 'VIDEO') { tracking = false; return; }
      sx = e.clientX; sy = e.clientY; tracking = true;
    });
    lb.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    });
    lb.addEventListener('pointercancel', function () { tracking = false; });

    /* hover preview: desktop only, one clip at a time, nothing preloaded.
       Bound per-tile (not on document) and fully pointer-transparent so it
       can never sit between a mousedown and its click. */
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var hoverVid = null, hoverTile = null, hoverTimer = null;

      function killHover() {
        clearTimeout(hoverTimer);
        if (hoverVid) {
          try { hoverVid.pause(); } catch (e) {}
          hoverVid.removeAttribute('src'); hoverVid.load(); hoverVid.remove();
        }
        hoverVid = null; hoverTile = null;
      }

      function bindPreviews() {
        document.querySelectorAll('.vid:not([data-prev])').forEach(function (tile) {
          tile.setAttribute('data-prev', '1');
          var host = tile.querySelector('.ph');
          if (!host) return;
          tile.addEventListener('mouseenter', function () {
            if (open || hoverTile === tile) return;
            killHover();
            hoverTile = tile;
            hoverTimer = setTimeout(function () {
              if (hoverTile !== tile) return;
              var v = document.createElement('video');
              v.className = 'vid__prev';
              v.src = tile.dataset.lb;
              v.muted = true; v.loop = true; v.playsInline = true;
              v.setAttribute('playsinline', ''); v.preload = 'none';
              host.appendChild(v);
              hoverVid = v;
              var pr = v.play();
              if (pr && pr.catch) pr.catch(function () {});
              requestAnimationFrame(function () { if (hoverVid === v) v.classList.add('is-in'); });
            }, 190);
          });
          tile.addEventListener('mouseleave', function () {
            if (hoverTile === tile) killHover();
          });
        });
      }
      bindPreviews();
      document.addEventListener('tlab:render', bindPreviews);
      window.addEventListener('pagehide', killHover);
    }
  }
})();
